// ContactInfo.js
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../styles/checkout.scss";
import { updateUser } from "../actions/authActions";
import { $startLoader, $stopLoader } from "../globals";
import { toast } from "react-toastify";
const ContactInfo = ({ data, setData, expanded }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [form, setForm] = useState(data || {});
  const [newPhone, setNewPhone] = useState("");

  useEffect(() => {
    if (
      user?.phone &&
      (!data?.primaryPhone || data.primaryPhone !== user.phone)
    ) {
      const updatedForm = {
        primaryPhone: user.phone,
        secondaryPhone: data?.secondaryPhone || "",
      };
      setForm(updatedForm);
      setData(updatedForm);
      setNewPhone(user.phone);
    }
  }, [user?.phone, data, setData]);

  const handleChange = (e) => {
    setNewPhone(e.target.value);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    try {
      $startLoader();
      dispatch(updateUser({ phone: newPhone }));
      toast.success("Phone number updated successfully!");
      setForm({ ...form, primaryPhone: newPhone });
      setData({ ...data, primaryPhone: newPhone });
      $stopLoader();
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className={`contactInfoForm ${expanded ? "expanded" : ""}`}>
      <div>
        <label className="checkoutLabel">Primary Phone Number *</label>
        <div className="input-wbutton">
          <input
            className="checkoutInput"
            type="tel"
            name="primaryPhone"
            value={newPhone || ""}
            onChange={handleChange}
            required
            disabled={!expanded}
          />
          <button className="checkoutButton" onClick={handleUpdate}>
            Save
          </button>
        </div>
      </div>
      {/* <div>
        <label className="checkoutLabel">
          Secondary Phone Number (Optional)
        </label>
        <input
          className="checkoutInput"
          type="tel"
          name="secondaryPhone"
          value={form.secondaryPhone || ""}
          onChange={handleChange}
          placeholder="e.g., 0782498881"
        />
      </div> */}
    </div>
  );
};

export default ContactInfo;
